export default "__VITE_ASSET__CFaFmCsL__"